import { render, staticRenderFns } from "./SendMessageGroupRegister.vue?vue&type=template&id=91fe2700&scoped=true&lang=pug"
import script from "./SendMessageGroupRegister.vue?vue&type=script&lang=ts"
export * from "./SendMessageGroupRegister.vue?vue&type=script&lang=ts"
import style0 from "./SendMessageGroupRegister.vue?vue&type=style&index=0&id=91fe2700&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91fe2700",
  null
  
)

export default component.exports